import React from "react";
//import PropTypes from 'prop-types';
import { DropTarget } from "react-dnd";
import find from "lodash.find";
import Separator from "./Separator";

import { connect } from "../../utils";
import { DivEmpty } from "./styled";
import "./index.css";
import { data } from "../../addons/props/components/bgTheme";
const target = {
  drop(props, monitor, component) {
    if (!monitor.didDrop()) {
      props.layoutState.insertOrMoveItem(
        props.id,
        props.children.length,
        monitor.getItem()
      );
    }
  }
};
const checkImage = id => {
  let image = "";
  let result = find(data, function(item) {
    return item.id === id;
  });
  if (result) {
    return result.bg;
  }

  return image;
};
const EditLayout = ({
  id,
  children,
  isOverCurrent,
  connectDropTarget,
  type,
  layoutState,
  readOnly
}) => {
  const { values } = layoutState.getItemJS(id).props;
  let parsedChildren = [];
  if (!readOnly && children.length) {
    for (let i = 0; i < children.length * 2 + 1; i++) {
      if (i % 2 === 0) {
        parsedChildren.push(
          <Separator
            key={`${id}-seperator-${i}`}
            onDrop={item => layoutState.insertOrMoveItem(id, i / 2, item)}
            direction={"horizontal"}
          />
        );
      } else {
        parsedChildren.push(children[(i - 1) / 2]);
      }
    }
  } else {
    parsedChildren = children;
  }

  return connectDropTarget(
    <div
      className="fullheight"
      style={{
        backgroundColor: values.backgroundColor,
        backgroundImage: `url(${checkImage(values.backgroundImage.url)})`,
        backgroundRepeat: "repeat",
        padding: "2px 2px 20px 2px"
      }}
    >
      {children.length < 1 && (
        <DivEmpty>No row yet. Drag a row from the left to here</DivEmpty>
      )}
      {parsedChildren}
    </div>
  );
};

const LayoutContainer = DropTarget("Body", target, (conn, monitor) => ({
  connectDropTarget: conn.dropTarget(),
  isOverCurrent: monitor.isOver({ shallow: true })
}))(EditLayout);

export default connect("layoutState", "readOnly")(LayoutContainer);



// WEBPACK FOOTER //
// ./src/editor/layout/components/Layout/DnDBody.js